<div class="d-flex align-items-center">
    <div class="mr-auto">
        <p class="my-0" translate>
            Please review repair options before applying the fix. <br/>
            The script can also be updated later.
        </p>
    </div>
    <div class="d-flex align-items-center">
        <span [ngClass]="['ADMIN', 'DOMAINS', 'WARNING'] | monIcons"
              class="fa-2x mr-2 warning"
              *ngIf="warning"
              ngbTooltip="{{warning}}"
              [triggers]="'focus hover'"
              aria-hidden="true">
        </span>
        <button class="btn btn-border-radius btn-secondary mr-2"
                data-test="remove-button"
                type="button"
                (click)="removeCheck()"
                *ngIf="pageFixApplied"
                [disabled]="saving || removing">
            {{ 'Remove' | translate }}
            <span [ngClass]="{'fas fa-spinner fa-spin': removing}" aria-hidden="true"></span>
        </button>
        <button class="btn btn-border-radius btn-marine-blue"
                data-test="update-button"
                [disabled]="!formValid || saving"
                type="submit"
                *ngIf="pageFixApplied"
                (click)="submit()">
            {{ 'Update' | translate }}
            <span [ngClass]="{'fas fa-spinner fa-spin': saving}" aria-hidden="true"></span>
        </button>
        <button class="btn btn-border-radius btn-marine-blue"
                data-test="apply-fix-button"
                [disabled]="!formValid || saving"
                type="submit"
                *ngIf="!pageFixApplied"
                (click)="submit()">
            {{ 'Apply fix' | translate }}
            <span [ngClass]="{'fas fa-spinner fa-spin': saving}" aria-hidden="true"></span>
        </button>
    </div>
</div>
